import UPLOAD_SCREENSHOT from '../../graphql/screenshots/upload.gql';
import DELETE_SCREENSHOT from '../../graphql/screenshots/delete.gql';
import {apolloClient} from "../../plugins/apollo-client";

const uploadScreenShot = (file, callSid) =>
  apolloClient.mutate({
    mutation: UPLOAD_SCREENSHOT,
    variables: {
      file,
      callSid
    }
  }).then(({data: {screenshot}}) => screenshot);

const deleteScreenShot = (id) =>
  apolloClient.mutate({
    mutation: DELETE_SCREENSHOT,
    variables: {
      id
    }
  }).then(({data: {screenshot}}) => screenshot);

export {
  uploadScreenShot,
  deleteScreenShot
}
